import axios from "axios";
import { Base_URL } from "../url";

export const saveEmployeeType = async (data) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId; 
    const response = await axios.post(
      `${Base_URL}/EmployeeTypeMaster/CreateEmployeeType?UserName=${userId}`,
      data
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving employee type!";
  }
};
